import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminCoupons from './AdminCoupons';
import AdminSales from './AdminSales';
import './AdminPromotions.css';

const AdminPromotions: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // The URL is the single source of truth for which tab is active:
  // /admin/sales shows Sales; /admin/coupons and /admin/promotions show Coupons.
  const activeTab: 'coupons' | 'sales' = location.pathname.endsWith('/sales') ? 'sales' : 'coupons';

  const handleTabChange = (tab: 'coupons' | 'sales'): void => {
    navigate(tab === 'sales' ? '/admin/sales' : '/admin/coupons');
  };

  return (
    <div className="admin-promotions">
      <div className="promotions-header">
        <h1>Promotions Management</h1>
        <div className="promotions-tabs">
          <button
            className={`tab-button ${activeTab === 'coupons' ? 'active' : ''}`}
            onClick={() => handleTabChange('coupons')}
          >
            <i className="fas fa-ticket-alt"></i> Coupons
          </button>
          <button
            className={`tab-button ${activeTab === 'sales' ? 'active' : ''}`}
            onClick={() => handleTabChange('sales')}
          >
            <i className="fas fa-tags"></i> Sales
          </button>
        </div>
      </div>

      <div className="promotions-content">
        {activeTab === 'coupons' && <AdminCoupons />}
        {activeTab === 'sales' && <AdminSales />}
      </div>
    </div>
  );
};

export default AdminPromotions;
